<template>
  <div>
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <div class="width100 margin-auto backwhite border-rd3">
          <div class="width96 margin-auto backwhite bordert-bf pad-bot20">
            <div class="flex-betweenNowrapAlign pad-top30">
              <p
                class="f24 textalign-left"
                style="font-weight: 600; color: #353a44"
              >
                {{ title }}
              </p>
              <p class="textalign-center">
                <span class="f14" v-if="defaultcid">
                  <i
                    v-if="nullwujiao"
                    slot="prefix"
                    class="
                      iconfont
                      iconfonte
                      icon-a-wujiaoxingxingxing
                      blucolor
                    "
                    @click="policySubscribe()"
                  ></i>
                  <i
                    v-if="wujiao"
                    slot="prefix"
                    class="iconfont iconfonte icon-wujiaoxing blucolor"
                    @click="policyunsubscribe()"
                  ></i
                  ><span v-if="nullwujiao">订阅</span
                  ><span v-if="wujiao">取消订阅</span></span
                >
                <span
                  class="margin-left10 attention cursorpointer f14"
                  @click="policecs()"
                >
                  匹配度测试
                </span>
                <span
                  class="margin-left10 attention cursorpointer f14"
                  @click="dialogtrusteeship = true"
                >
                  委托申报
                </span>
              </p>
            </div>
            <p class="pad-top20 dimencont f14">
              <span>政策资金:{{ money }}-{{ max_money }}万元 </span>
              <span class="pad-left10"> 申报截至:{{ end_time }}</span>
            </p>
          </div>
          <div
            v-html="content"
            class="pad-top20 f14 lineheight25 width96 margin-auto"
          ></div>
          <div class="width98 margin-auto pad-bot10">
            <div
              class="
                backgroudF9
                bluecolor
                margin-bot10
                pad-top10 pad-bot10 pad-left10
                f14
              "
            >
              附件
            </div>
            <div
              class="f14 lineheight25 pad-left10 pad-bot10"
              v-for="(item, index) in attachments"
              :key="index"
            >
              <a :href="item.url" class="flex f12">
                <p class="bluecolor margin-right20">
                  <img src="@/assets/barsvg/icon／12fj.png" alt="" />
                  {{ item.original_name }}
                </p>
                <p style="color: #969eac">上传时间：{{ item.create_time }}</p>
              </a>
            </div>
          </div>
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <!-- 委托申报 -->
    <el-dialog
      title=""
      :visible.sync="dialogtrusteeship"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      close="errorbox"
    >
      <div class="pad-bot20">
        <p class="f16 width98 textalign-left dimensional">委托申报</p>
      </div>
      <div class="bg-box">
        <p class="width100 textalign-left pad-bot5">联系人名称</p>
        <div class="box-right">
          <el-input
            class="inputDeep"
            placeholder="请输入联系人名称"
            v-model="input"
          ></el-input>
        </div>
      </div>
      <div class="bg-box">
        <p class="width100 textalign-left pad-bot5">联系时间</p>
        <div class="box-right">
          <el-date-picker
            class="inputDeep"
            v-model="warnDate"
            type="date"
            placeholder="请选择研发融资时间"
            value-format="yyyy-MM-dd"
            :editable="false"
          ></el-date-picker>
        </div>
      </div>
      <div class="bg-box">
        <p class="width100 textalign-left pad-bot5">备注</p>
        <div class="box-right">
          <el-input
            type="textarea"
            :autosize="autosize"
            v-model="textarea"
            placeholder="请输入委托备注,非必填"
            class="inputDeep"
            maxlength="200"
            rows="5"
            cols="20"
          ></el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="trusteeshipsure()"
          class="dialogbut cursorpointer"
          >确 定</el-button
        >
        <el-button
          @click="dialogtrusteeship = false"
          class="dialogbut cursorpointer"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 匹配度测试 -->
    <el-dialog
      title=""
      :visible.sync="dialogtrusteecs"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      close="errorbox"
    >
      <div class="pad-bot20">
        <p
          class="f16 width98 textalign-left"
          style="color: #353a44; font-weight: 600"
        >
          匹配度测试
        </p>
      </div>
      <div>
        <div>
          <div>
            <div class="pad-bot30">
              <div
                v-for="(item, index) in pages"
                :key="index"
                class="flex-betweenNowrapAlign margin-top20"
              >
                <div class="flex">
                  <div class="burderre"></div>
                  <div
                    :class="item.result == true ? 'succescolor' : 'errorcolor'"
                  >
                    {{ item.condition_name }}
                  </div>
                </div>

                <div>
                  <img
                    v-if="item.result == true"
                    src="@/assets/barsvg/icon／14wc.png"
                    alt=""
                  /><img
                    v-if="item.result != true"
                    src="@/assets/barsvg/icon／14zy.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="soltbox border-rd3" v-show="soltbox">
          <p class="f18 bluecolor pad-top20 pad-left20">
            政策匹配分值:{{ score }}%
          </p>
          <p class="f14 pad-top20 pad-left20 pad-right10">{{ message }}</p>
        </div>
        <div class="textalign-right margin-top20" v-show="soltbox">
          <el-button type="primary" @click="dialogtrusteeship = true">
            委托申报
          </el-button>
          <el-button @click="backpolice"> 关闭 </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
    <script>
import {
  policydetail,
  policySubscribe,
  policyunsubscribe,
  policygetresult,
} from "@/api/Center/Center.api";
import { entpolicyapplysave } from "@/api/newhead/newhead.api";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      dialogtrusteeship: false,
      dialogtrusteecs: false,
      value: "",
      warnDate: "",
      title: "",
      money: "",
      max_money: "",
      end_time: "",
      content: "",
      projectName: "",
      attachments: [],
      nullwujiao: false,
      wujiao: false,
      zhengcheNum: "",
      input: "",
      textarea: "",
      defaultcid: true,
      active: 0,
      page: [],
      pages: [],
      page1: [],
      message: "",
      score: "",
      soltbox: false,
    };
  },

  components: {},
  methods: {
    //订阅政策
    policySubscribe() {
      policySubscribe({ chance_id: this.zhengcheNum }).then((res) => {
        if (res.data.code == 200) {
          this.wujiao = true;
          this.nullwujiao = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    //取消订阅
    policyunsubscribe() {
      policyunsubscribe({ id: this.zhengcheNum }).then((res) => {
        if (res.data.code == 200) {
          this.nullwujiao = true;
          this.wujiao = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 委托申报
    trusteeshipsure() {
      entpolicyapplysave({
        chance_id: parseInt(this.zhengcheNum),
        contact: this.input,
        contact_date: this.warnDate,
        remark: this.textarea,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "已提交",
            type: "success",
          });

          this.dialogtrusteeship = false;
          policydetail({ id: parseInt(this.zhengcheNum) }).then((res) => {
            if (res.data.code == 200) {
              this.page1 = res.data.data;
              this.title = this.page1.title;
              this.money = this.page1.money;
              this.max_money = this.page1.max_money;
              this.end_time = this.page1.end_time;
              this.content = this.page1.content;
              this.attachments = res.data.data.attachments;
              this.subscribe = this.page1.subscribe;
              if (this.subscribe == 0) {
                this.nullwujiao = true;
              } else {
                this.wujiao = true;
              }
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    policecs() {
      this.dialogtrusteecs = true;
      const zhengcheNum = window.sessionStorage.getItem("policydetailid");
      policygetresult({ chance_id: parseInt(zhengcheNum) }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.message = res.data.data.message;
          this.score = res.data.data.score;
          let n = -1;
          var time = setInterval(() => {
            this.pages.push(this.page[++n]);
            this.active = ++this.active;
            if (this.pages.length == res.data.data.data.length) {
              clearInterval(time);
              this.soltbox = true;
            }
          }, 500);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 返回按钮
    backpolice() {
      this.dialogtrusteecs = false;
      this.page = [];
      this.pages = [];
      this.soltbox = false;
    },
  },
  // 监听匹配度测试状态
  watch: {
    dialogtrusteecs() {
      if (this.dialogtrusteecs == false) {
        this.page = [];
        this.pages = [];
        this.soltbox = false;
      }
    },
  },
  created() {
    if (window.sessionStorage.getItem("default") == 0) {
      this.defaultcid = false;
    } else {
      this.defaultcid = true;
    }
    this.zhengcheNum = window.sessionStorage.getItem("policydetailid");
    policydetail({ id: this.zhengcheNum }).then((res) => {
      if (res.data.code == 200) {
        this.page1 = res.data.data;
        this.title = this.page1.title;
        this.money = this.page1.money;
        this.max_money = this.page1.max_money;
        this.end_time = this.page1.end_time;
        this.content = this.page1.content;
        this.attachments = res.data.data.attachments;
        this.subscribe = this.page1.subscribe;
        if (this.subscribe == 0) {
          this.nullwujiao = true;
        } else {
          this.wujiao = true;
        }
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
    <style scoped>
.soltbox {
  width: 96%;
  margin: auto;
  min-height: 142px;
  background: rgba(82, 197, 203, 0.11);
  border-radius: 3px;
  border: 1px dashed #52c5cb;
}
.burderre {
  margin-top: 5px;
  margin-right: 10px;
  width: 8px;
  height: 8px;
  background: #f0f0f0;
  border-radius: 50%;
}
.succescolor {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #353a44;
}
.errorcolor {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #969eac;
}
.inputDeep {
  text-align: right;
}
/* 表单盒子 */
.bg-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 0 0 0;
  color: #4f4f4f;
  font-size: 14px;
}
.but-box {
  width: 50%;
  margin: 20px auto 0;
}

.box-right {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}
.button {
  width: 60px;
  height: 26px;
  font-size: 14px;
  color: white;
  background: #a4adb3;
  border: none;
  border-radius: 5px;
}

::placeholder {
  color: #a4a4a4;
  font-size: 12px;
}
.el-input {
  width: 100%;
}
.textarea >>> .el-textarea__inner {
  width: 120%;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>

                                                                                                                                      